import { api, defaultQueriesFor } from '../apiSlice';

export const userApi = api
  .enhanceEndpoints({ addTagTypes: ['User'] })
  .injectEndpoints({
    endpoints: build => ({
      ...defaultQueriesFor(build, 'User', 'Users', true),

      addCustomerToList: build.mutation({
        query: (email) => ({
          url: '/users/add_customer_to_list',
          method: 'POST',
          body: { email },
        }),
      }),
    }),
  });

export const {
  useCreateUserMutation,
  useDeleteUserMutation,
  useGetUserByIdQuery,
  useGetUsersQuery,
  useUpdateUserMutation,
  useAddCustomerToListMutation,
} = userApi;
